import axios from 'axios'

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})


class API {
    /**
     * @param {string} tangledIdemGUID
     */
    async listCampaign(tangledIdemGUID) {
        return (await api.get(`/campaign/?accountIdentifier=${tangledIdemGUID}`)).data
    }

    /**
     * @param {string} id
     * @param {string} tangledIdemGUID
     */
    async getCampaign(id, tangledIdemGUID) {
        return (await api.get(`/campaign/${id}/?accountIdentifier=${tangledIdemGUID}`)).data
    }

    /**
     * @param {string} type
     * @param {string} tangledIdemGUID
     */
    async isActive(type, tangledIdemGUID) {
        return (await api.get(`/campaign/active/${type}/?accountIdentifier=${tangledIdemGUID}`)).data
    }

    /**
     * @param {string} type
     * @param {string[]} targets
     * @param {string} message
     * @param {string} tangledIdemGUID
     */
    async createCampaign(type, targets, message, tangledIdemGUID) {
        return (await api.post(`/campaign/?accountIdentifier=${tangledIdemGUID}`, { type, targets, message })).data
    }

    async ping() { return (await api.get('/ping')).data }

    /**
     * @param {string} username
     * @param {string} tangledIdemGUID
     */
    async getUser(username, tangledIdemGUID) {
        return (await api.get(`/user/?accountIdentifier=${tangledIdemGUID}&accountUsername=${username}`)).data
    }

    /**
     * @param {string} token
     * @param {string} tangledIdemGUID
     */
    async getPendingSocialImpressions(token, tangledIdemGUID) {
        return (await api.get(`/campaign/social/pending/?accountIdentifier=${tangledIdemGUID}&token=${token}`)).data
    }


    /**
     * @param {string} token
     * @param {string} tangledIdemGUID
     */
    async validateToken(token, tangledIdemGUID) {
        return (await api.get(`/user/token/validate/?accountIdentifier=${tangledIdemGUID}&token=${token}`)).data
    }

    /**
     * @param {string}  campaignId
     * @param {boolean} isValid
     * @param {string}  token
     * @param {string}  tangledIdemGUID
     */
    async validateSocialShareCampaign(campaignId, isValid, token, tangledIdemGUID) {
        return (await api.put(`/campaign/social/validate/${campaignId}/?accountIdentifier=${tangledIdemGUID}&token=${token}`, { isValid })).data
    }
}

export default new API;
